export enum ERoleName {
  ADMIN = 'admin',
  USER = 'user',
}

export interface IRoleDto {
  id: number
  name: ERoleName
}
